/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setMouseStalker.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * 要素を作成
 */
const stalkerDiv = document.createElement("div");
const stalkerSpan = document.createElement("span");
stalkerDiv.id = "stalker";
stalkerSpan.id = "stalker-point";
document.body.appendChild(stalkerDiv);
stalkerDiv.appendChild(stalkerSpan);

const stalker = document.getElementById("stalker");

/**
 * カーソルに"#stalker"を追従
 */
const setMouseStalker = () => {
  if (window.matchMedia("(min-width: 1025px)").matches) {
    document.addEventListener("mousemove", function (e) {
      stalker.style.transform =
        "translate(" + e.clientX + "px, " + e.clientY + "px)";
    });
  }
};

/**
 * スライドボタンに".swiper-button-disabled"付与時、指定のマウスストーカー解除
 */
const removeSlideButtonMouseStalker = () => {
  var NextButton = document.getElementById('sliderButtonNext');
  var PrevButton = document.getElementById('sliderButtonPrev');

  PrevButton.addEventListener("click", (e) => {
    let currentbutton = e.currentTarget;
    if (currentbutton.classList.contains("swiper-button-disabled")) {
      stalker.classList.remove("next");
      stalker.classList.remove("prev");
    }
  });

  NextButton.addEventListener("click", (e) => {
    let currentbutton = e.currentTarget;
    if (currentbutton.classList.contains("swiper-button-disabled")) {
      stalker.classList.remove("next");
      stalker.classList.remove("prev");
    }
  });
}

const removeSlideButtonDigitalMouseStalker = () => {
  var NextButton = document.getElementById('sliderButtonNext');
  var PrevButton = document.getElementById('sliderButtonPrev');
  var NextButtonDigital = document.getElementById('sliderButtonNext_digital');
  var PrevButtonDigital = document.getElementById('sliderButtonPrev_digital');

  PrevButton.addEventListener("click", (e) => {
    let currentbutton = e.currentTarget;
    if (currentbutton.classList.contains("swiper-button-disabled")) {
      stalker.classList.remove("next");
      stalker.classList.remove("prev");
    }
  });

  NextButton.addEventListener("click", (e) => {
    let currentbutton = e.currentTarget;
    if (currentbutton.classList.contains("swiper-button-disabled")) {
      stalker.classList.remove("next");
      stalker.classList.remove("prev");
    }
  });

  PrevButtonDigital.addEventListener("click", (e) => {
    let currentbutton = e.currentTarget;
    if (currentbutton.classList.contains("swiper-button-disabled")) {
      stalker.classList.remove("next");
      stalker.classList.remove("prev");
    }
  });

  NextButtonDigital.addEventListener("click", (e) => {
    let currentbutton = e.currentTarget;
    if (currentbutton.classList.contains("swiper-button-disabled")) {
      stalker.classList.remove("next");
      stalker.classList.remove("prev");
    }
  });
}

/**
 * 特定エリアをホバーでポインター変化
 */
const setMouseStalkerTransform = () => {
  if (window.matchMedia("(min-width: 768px)").matches) {
    const mouseTransformArea = document.querySelectorAll(
      ".js-mouse-transform-area"
    );

    for (let i = 0; i < mouseTransformArea.length; i++) {
      mouseTransformArea[i].addEventListener("mouseover", (e) => {
        let currentArea = e.currentTarget;
        document.body.classList.add("mouse-transform");
        if (currentArea.classList.contains("transform-scroll")) {
          stalker.classList.add("scroll");
        }
        if (currentArea.classList.contains("transform-more")) {
          stalker.classList.add("more");
        }
        if (currentArea.classList.contains("transform-play")) {
          stalker.classList.add("play");
        }
        if (currentArea.classList.contains("transform-coming_soon")) {
          stalker.classList.add("coming_soon");
        }
        if (currentArea.classList.contains("transform-next")) {
          stalker.classList.add("next");
        }
        if (currentArea.classList.contains("transform-prev")) {
          stalker.classList.add("prev");
        }
      });
      mouseTransformArea[i].addEventListener("mouseleave", function () {
        document.body.classList.remove("mouse-transform");
        stalker.classList.remove("scroll");
        stalker.classList.remove("more");
        stalker.classList.remove("play");
        stalker.classList.remove("coming_soon");
        stalker.classList.remove("next");
        stalker.classList.remove("prev");
      });
    }

    if (window.document.body.classList.contains("interviewee")) {
      removeSlideButtonMouseStalker();
    }
    if (window.document.body.classList.contains("department")) {
      removeSlideButtonDigitalMouseStalker();
    }
  }
};

export { setMouseStalker, setMouseStalkerTransform };
